module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.link) ? _c('router-link', {
    staticClass: "alp-big-theme-wrapper",
    attrs: {
      "to": _vm.to
    }
  }, [_c('div', {
    staticClass: "alp-big-theme",
    style: (_vm.backgroundImage)
  }, [_c('div', {
    staticClass: "alp-big-theme__shadow"
  }, [_vm._t("default")], 2)])]) : _c('div', {
    staticClass: "alp-big-theme-wrapper"
  }, [_c('div', {
    staticClass: "alp-big-theme alp-big-theme--no-hover",
    style: (_vm.backgroundImage)
  }, [_c('div', {
    staticClass: "alp-big-theme__shadow"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "alp-big-theme__shadow__back",
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/arrow.left.png"),
      "alt": "left arrow"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295fd97c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/BigTheme.vue
// module id = 178
// module chunks = 0